import type { FC } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Alert, Button, Dialog } from '@/ui';

import { resolveApiErrorMessage } from '../../lib/apiError';
import { useReturnShipmentToPlan } from './api/mutations';

/*
 * «Назад по этапу» - подтверждение: «Согласование» -> «Запланировано». Доступно,
 * пока в 1С нет заказа; дальше статус ведёт заказ 1С (ADR-012) - это отсекает
 * сервер (409), а кнопку прячет карточка.
 */

export interface ReturnToPlanDialogProps {
  shipmentId: string;
  shipmentNumber: number | string;
  onClose: () => void;
}

export const ReturnToPlanDialog: FC<ReturnToPlanDialogProps> = ({
  shipmentId,
  shipmentNumber,
  onClose,
}) => {
  const returnToPlan = useReturnShipmentToPlan();

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={`Вернуть отгрузку № ${shipmentNumber} в план`}
      footer={
        <>
          <Button onClick={onClose}>Не возвращать</Button>
          <Button
            variant="primary"
            disabled={returnToPlan.isPending}
            onClick={() =>
              returnToPlan.mutate(
                { path: { id: shipmentId } },
                { onSuccess: onClose },
              )
            }
          >
            <ArrowLeft aria-hidden /> Вернуть в «Запланировано»
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-2.5 text-[13px] text-ink-700">
        <p className="m-0">
          Отгрузка вернётся из «Согласования» в «Запланировано». Отметки шагов
          согласования снимутся: после «Взять в работу» их нужно будет отметить
          заново.
        </p>
        <p className="m-0">
          Следующие отгрузки, созданные при «Взять в работу», останутся в плане
          - повторное «Взять в работу» их не продублирует.
        </p>
      </div>
      {returnToPlan.isError && (
        <Alert tone="error" className="mt-3.5">
          Не удалось вернуть: {resolveApiErrorMessage(returnToPlan.error)}
        </Alert>
      )}
    </Dialog>
  );
};
